import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyDjwhFMJtTH8VRg7RG--DE2HEFQqRQQFvU",
    authDomain: "muso-ninjas-558e7.firebaseapp.com",
    projectId: "muso-ninjas-558e7",
    storageBucket: "muso-ninjas-558e7.appspot.com",
    messagingSenderId: "1037684794611",
    appId: "1:1037684794611:web:43288a954d77764fd38386"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()
const projectStorage = firebase.storage()

// timestamp
const timestamp = firebase.firestore.FieldValue.serverTimestamp

export { projectFirestore, projectAuth, projectStorage, timestamp }